import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        listItem: {
            paddingBottom: "0",
            paddingTop: "0",
            marginTop: "4px"
        },
        extensionList: {
          paddingBottom: "0",
          paddingTop: "0",
          marginTop: "8px"
        },
        fileModalBody: {
           padding: "0",
           borderRadius: "0 10px 10px 10px",
           background: "#FFFFFF"
        },
        fileModalFooter: {
          padding: "0.2rem 0.5rem"
        },
        filesList: {
          paddingBottom: "10px",
          overflowY: "auto",
          "&::-webkit-scrollbar": {
            width: "12px",
          },
          "&::-webkit-scrollbar-track": {
            borderRadius: "5px",
            backgroundColor: "#e7e6ee"
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#c9c9d1",
            borderRadius: "5px"
          },
          maxHeight: "300px"
        }
    })
);